export const API_URL = process.env.BACKEND_URL
export const SITEMAP_PARSE_API = API_URL + '/sitemap/parse'
export const CRAWLER_API = API_URL + '/crawler'
export const SITEMAP_RESTART_API = API_URL + '/sitemap/restart'
export const BILLING_TOKEN_API = API_URL + '/billing/token'
export const SUBSCRIPTION_API = API_URL + '/billing/subscription'
export const SITE_INFO_API = API_URL + '/site-info'
export const SITE_DELETE_API = API_URL + '/site/delete'

// Route paths
export const HOME_PATH = '/'
export const REGISTER_PATH = '/register'
export const PASSWORD_PATH = '/password'
export const SIGN_IN_PATH = '/sign-in'

export const ACCOUNT_PATH = '/account'
export const ACCOUNT_BILLING_PATH = `${ACCOUNT_PATH}/billing`

export const SITES_PATH = '/sites'
export const ADD_SITE_PATH = `${SITES_PATH}/add`

export const SITE_PATH = `${SITES_PATH}/:site`
export const SITE_EDIT_PATH = `${SITE_PATH}/edit`

export const HISTORY_PATH = `${SITE_PATH}/history`
export const LINKS_LIST_PATH = `${HISTORY_PATH}/:queue`

export const SITE_SCHEDULES_PATH = `${SITE_PATH}/schedules`

export const POST_SIGN_IN_PATH = SITES_PATH
export const POST_SIGN_OUT_PATH = HOME_PATH

export const subscriptionPlans = {
  basic: { title: 'Basic', price: 0, limit: '100,000' },
  cacheready_pro: { title: 'Professional', price: 14, limit: '1,000,000' }, // eslint-disable-line camelcase
  cacheready_unlimited: { title: 'Unlimited', price: 49, limit: 'unlimited' }, // eslint-disable-line camelcase
}



// WEBPACK FOOTER //
// ./src/config.js